:host {
  display: block;
}

.component {
  .scroll-view-wrapper {
    .chips-wrapper {
      display: flex;
      gap: $baseline-2;

      .chip {
        flex: 0 0 auto;
      }
    }

    &.space {
      margin-top: $baseline-4;
    }
  }

  .result {
    display: block;
    margin-top: $baseline-2;
  }
}
